import { useEffect, useState } from "react";
import { ILive } from "../../helpers/types";
import { liveService } from "../../services";

const useFetchPublicEvent = (eventId: string) => {
  const [event, setEvent] = useState<ILive | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!eventId) return;

    const fetchEvent = async () => {
      setLoading(true);
      setError(null);
      try {
        const liveEvent = await liveService.getPublicLiveById(eventId);
        setEvent(liveEvent);
      } catch (err: any) {
        setError(err?.message || "Failed to fetch event");
        setEvent(null);
      } finally {
        setLoading(false);
      }
    };

    fetchEvent();
  }, [eventId]);

  return { loading, error, event };
};

export default useFetchPublicEvent;
